import request from '../request';
import qs from 'qs'

export const getProjectHQStagesApi = async (projectId: string | number) => {
    return await request.get<any, API.PROJECTHQ.Stage[]>(`/workbenchApi/checklists/projects/${projectId}/stages`);
};

export const getProjectHQTasksApi = async (projectStageTypeId: string | number) => {
    return await request.get<any, API.PROJECTHQ.TypeTask[]>(`/workbenchApi/checklists/project-stage-types/${projectStageTypeId}/tasks`);
};

export const updateProjectHQTaskStatusApi = async (taskId: string | number, status: number) => {
    return await request.patch<any, API.PROJECTHQ.TypeTask>(`/workbenchApi/checklists/tasks/${taskId}/status`, { status });
};

export const updateProjectHQTaskCompletedAtApi = async (taskId: string | number, completedAt: string) => {
    return await request.patch<any, API.PROJECTHQ.TypeTask>(`/workbenchApi/checklists/tasks/${taskId}/completed-at`, { completedAt });
};

export const uploadFileToProjectHQTaskApi = async (taskId: string | number, formData: FormData) => {
    return await request.post<any, API.PROJECTHQ.TypeTask>(`/workbenchApi/checklists/tasks/${taskId}/upload`, formData);
};

export const getProjectHQTaskAttachmentsApi = async (taskId: string | number) => {
    return await request.get<any, API.DDSFile[]>(`/workbenchApi/checklists/tasks/${taskId}/files`);
};
export const deleteProjectHQTaskAttachmentApi = async (fileId: string | number) => {
    return await request.delete<any, any>(`/workbenchApi/checklists/tasks/files/${fileId}`);
};